import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { FC } from 'react';
import { CollectionInsightType } from '@components/collections/Model';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { ProductsLeaderboardDoubleBarChartInsight } from '@components/collections/products-leaderboard-double-bar-chart/Model';
import classnames from 'classnames';
import * as styles from './ProductsLeaderboardCollectionButton.module.scss';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';

export interface ProductsLeaderboardCollectionButtonProps {
  isDisabled: boolean;
  createInsightDataFn: CreateInsightDataFn<ProductsLeaderboardDoubleBarChartInsight>;
  createViewStateFn?: CreateViewStateFn<any>;
}

const ProductsLeaderboardCollectionButton: FC<ProductsLeaderboardCollectionButtonProps> = ({
  isDisabled,
  createInsightDataFn,
  createViewStateFn,
}) => {
  const pagesConfig = usePageConfig();

  return (
    <div
      className={classnames([
        {
          [styles.CategoryLeaderboardCollectionButton]: !isDisabled,
          [styles.CategoryLeaderboardCollectionButtonDisabled]: isDisabled,
        },
      ])}
    >
      <AddInsightToCollectionsButton<ProductsLeaderboardDoubleBarChartInsight>
        type={CollectionInsightType.ProductsDoubleBarChart}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
        createViewStateFn={createViewStateFn}
      />
    </div>
  );
};

export default ProductsLeaderboardCollectionButton;
